const carouselItems = [
  {
    title: '韩漫盛宴：2024年度必看作品大盘点',
    desc: '从热血战斗到甜蜜恋爱，精选年度最值得一看的韩漫作品，每一部都是口碑爆款。',
    tag: '年度专题',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20Korean%20webtoon%20style%20illustration%20collage%20with%20various%20characters%2C%20warm%20orange%20and%20gold%20gradient%2C%20energetic%20composition%2C%20modern%20digital%20art%2C%20clean%20atmospheric%20background&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '日漫经典：Jump系名作回顾特辑',
    desc: '重温少年Jump黄金时代的经典日漫，《海贼王》《火影忍者》《死神》等不朽名作。',
    tag: '经典专题',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20Japanese%20manga%20collection%20with%20classic%20Shonen%20Jump%20style%20art%2C%20warm%20vintage%20tones%2C%20action%20pose%20characters%2C%20dynamic%20composition%2C%20clean%20atmospheric%20background&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '国漫力量：不可错过的国产漫画推荐',
    desc: '国漫崛起正当时，精选国产漫画精品力作，感受中国漫画创作者的独特魅力与创意。',
    tag: '国漫专题',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20style%20comic%20art%20with%20traditional%20ink%20and%20modern%20digital%20fusion%2C%20warm%20amber%20and%20gold%20tones%2C%20martial%20arts%20theme%2C%20elegant%20composition%2C%20clean%20atmospheric%20background&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '下拉式阅读：最舒适的漫画浏览方式',
    desc: '告别传统翻页，体验纵向连续滚动的下拉式全集阅读模式，沉浸式追漫新体验。',
    tag: '功能专题',
    img: 'https://readdy.ai/api/search-image?query=Modern%20tablet%20displaying%20continuous%20vertical%20scroll%20webtoon%20reading%20experience%2C%20warm%20cozy%20lighting%2C%20digital%20reading%20environment%2C%20clean%20minimal%20composition%2C%20tech%20lifestyle%20photography&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    title: '恋爱甜宠漫画特辑：心动合集',
    desc: '收录评分最高的恋爱甜宠漫画，从青涩校园到成熟职场，甜度满分的浪漫故事。',
    tag: '恋爱专题',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20illustration%20with%20couples%20and%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20orange%20gradient%2C%20dreamy%20atmosphere%2C%20sweet%20and%20gentle%20composition%2C%20clean%20elegant%20background&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">精选专题</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">编辑团队精心策划的专题内容，深度解读热门漫画与阅读趋势</p>
        </div>

        <div className="flex flex-col gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group flex flex-col md:flex-row bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-full md:w-2/5 lg:w-1/3 flex-shrink-0 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-48 md:h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <span className="inline-block px-2.5 py-1 bg-secondary-100 text-secondary-700 text-xs font-semibold rounded-md mb-3 self-start whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}